import gql from 'graphql-tag';

export default gql(`
	query employee_favourites {
		employee_favourites {
			guid
			name
			visible_for_employees
			is_favourite
			is_favourited
		}
	}
`);

